// 9fbef606107a605d69c0edbcd8029e5d
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { scrollToElement, getIconPath } from '@tcp/core/src/utils';
import Carousel from '@tcp/core/src/components/common/molecules/Carousel';
import { COUPON_REDEMPTION_TYPE } from '@tcp/core/src/services/abstractors/CnC/CartItemTile';
import { renderLabel } from '@tcp/core/src/utils/labels/labelUtilty';
import withStyles from '../../../hoc/withStyles';
import CouponCard from '../../../molecules/CouponCard';
import Row from '../../../atoms/Row';
import Col from '../../../atoms/Col';
import BodyCopy from '../../../atoms/BodyCopy';
import Anchor from '../../../atoms/Anchor';

import styles from '../styles/CouponListSection.style';
import {
  SPC_CAROUSEL_ARROW,
  SPC_CAROUSEL_OPTIONS,
} from '../../../../features/CnC/SinglePageCheckout/container/SinglePageCheckout.constants';

class CouponListSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showMore: false,
    };
  }

  getShowMoreBtnDataLocator = (showMore) => {
    return showMore ? 'cartShowMoreButton' : 'cartShowLessButton';
  };

  toggleShow = (event) => {
    event.preventDefault();
    const { showMore } = this.state;
    this.setState(
      (prevState) => ({
        showMore: !prevState.showMore,
      }),
      () => {
        const couponDetailDOM = document.getElementsByClassName('cartDetailsLink')[4];
        if (couponDetailDOM) {
          couponDetailDOM.focus();
        }
        if (showMore) {
          const headingElem = document.querySelector('.couponList__title');
          const scrollTimer = setTimeout(() => {
            scrollToElement(headingElem);
            clearTimeout(scrollTimer);
          }, 100);
        }
      }
    );
  };

  scrollRight = () => {
    const carouselWrapper = document.getElementsByClassName('coupon-cards-container');
    if (carouselWrapper) {
      carouselWrapper[0].scrollLeft += 150;
    }
  };

  helpAnchorClick = (event) => {
    event.preventDefault();
    const { helpAnchorClick } = this.props;
    helpAnchorClick();
  };

  arrow = (couponListFilter) => {
    return (
      <>
        {couponListFilter?.size > 1 && (
          <BodyCopy onClick={() => this.scrollRight()} className="right-arrow" />
        )}
      </>
    );
  };

  getActivePlaceCashCoupon = () => {
    const { couponList } = this.props;
    if (couponList && couponList.size > 0) {
      const coupons = couponList.filter(
        (coupon) => coupon.offerType === COUPON_REDEMPTION_TYPE.PLACECASH && !coupon.isExpired
      );
      return coupons && coupons.size > 0;
    }
    return false;
  };

  render() {
    const {
      isFetching,
      couponList,
      className,
      heading,
      helpSubHeading,
      couponDetailClick,
      onApply,
      onRemove,
      dataLocator,
      handleErrorCoupon,
      showFullList,
      couponsOnHold,
      spc,
      spcBag,
      fromPaymentModal,
      afterpayCouponsInfo,
      setBonusPointDayCouponIndexAction,
      currentPerkLevel,
      checkoutLabels,
    } = this.props;
    const { showMore } = this.state;
    const buttonText =
      showMore === true
        ? renderLabel(
            checkoutLabels?.bagPage?.lbl_couponlist_lessMoreTxt,
            'lbl_couponlist_lessMoreTxt'
          )
        : renderLabel(
            checkoutLabels?.bagPage?.lbl_couponlist_showMoreTxt,
            'lbl_couponlist_showMoreTxt'
          );
    const couponListFilter =
      showMore === true || showFullList ? couponList : couponList.slice(0, 5);

    const CouponCardsWrapper = spc ? Carousel : Fragment;
    const couponCardsWrapperProps = spc
      ? {
          ...SPC_CAROUSEL_OPTIONS,
          carouselConfig: {
            autoplay: false,
            variation: 'big-arrows',
            customArrowLeft: getIconPath(SPC_CAROUSEL_ARROW),
            customArrowRight: getIconPath(SPC_CAROUSEL_ARROW),
          },
        }
      : {};

    const displayPlaceHelpLink = this.getActivePlaceCashCoupon();
    return (
      <div className={className} id="coupon-container">
        {!fromPaymentModal && (
          <div className="couponList__title">
            {couponList.size > 0 && (
              <BodyCopy
                className="couponList__heading"
                fontWeight="extrabold"
                component="h2"
                fontSize="fs14"
                data-locator={dataLocator}
                fontFamily="secondary"
              >
                {`${heading} (${couponList.size})`}
              </BodyCopy>
            )}
            {helpSubHeading && displayPlaceHelpLink > 0 && (
              <div className="couponList__iconContainer">
                <div className="couponList__helpIcon">?</div>
                <Anchor
                  fontSizeVariation="medium"
                  underline
                  anchorVariation="primary"
                  fontFamily="secondary"
                  dataLocator="couponcard-helpApplyingPlaceCashlink"
                  onClick={this.helpAnchorClick}
                >
                  {renderLabel(
                    checkoutLabels?.bagPage?.lbl_couponlist_helpAppling,
                    'lbl_couponlist_helpAppling'
                  )}
                </Anchor>
              </div>
            )}
          </div>
        )}
        {fromPaymentModal && (
          <BodyCopy
            className="elem-mb-LRG"
            fontWeight="regular"
            component="p"
            fontSize="fs16"
            data-locator={dataLocator}
            fontFamily="secondary"
          >
            {afterpayCouponsInfo}
          </BodyCopy>
        )}
        <Row fullBleed>
          <Col
            colSize={{
              small: 6,
              medium: 8,
              large: 12,
            }}
          >
            <div className={spc ? 'coupon-cards-container' : ''}>
              <CouponCardsWrapper {...couponCardsWrapperProps}>
                {couponListFilter.map((coupon) => {
                  return (
                    <CouponCard
                      key={coupon.id}
                      isFetching={isFetching}
                      coupon={coupon}
                      couponDetailClick={couponDetailClick}
                      onApply={onApply}
                      onRemove={onRemove}
                      handleErrorCoupon={handleErrorCoupon}
                      ref={this.couponRef}
                      couponsOnHold={couponsOnHold}
                      spc={spc}
                      spcBag={spcBag}
                      setBonusPointDayCouponIndexAction={setBonusPointDayCouponIndexAction}
                      currentPerkLevel={currentPerkLevel}
                    />
                  );
                })}
              </CouponCardsWrapper>
            </div>
          </Col>
        </Row>
        {!spc && (
          <div className="cart-show-more-btn">
            {couponList.size > 5 && (
              <Anchor
                fontSizeVariation="small"
                underline
                anchorVariation="primary"
                dataLocator={this.getShowMoreBtnDataLocator(showMore)}
                onClick={this.toggleShow}
                fontFamily="secondary"
              >
                <BodyCopy component="span" fontSize="fs12">
                  {buttonText}
                </BodyCopy>
              </Anchor>
            )}
          </div>
        )}
      </div>
    );
  }
}

CouponListSection.defaultProps = {
  couponsOnHold: false,
  spc: false,
  spcBag: false,
};

CouponListSection.propTypes = {
  helpAnchorClick: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  couponList: PropTypes.shape([]).isRequired,
  className: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  helpSubHeading: PropTypes.string.isRequired,
  couponDetailClick: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  dataLocator: PropTypes.string.isRequired,
  handleErrorCoupon: PropTypes.func.isRequired,
  showFullList: PropTypes.bool.isRequired,
  couponsOnHold: PropTypes.bool,
  spc: PropTypes.bool,
  spcBag: PropTypes.bool,
};

export default withStyles(CouponListSection, styles);
export { CouponListSection as CouponListSectionVanilla };
